module.exports = __webpack_public_path__ + "img/concrete-hole-decal-00.ed25dd50.png";